module.exports = __webpack_public_path__ + "img/my_coaching_active.a0d58725.svg";